import React from 'react'
import injectSheet from 'react-jss'

const StatusBar = (props) => {
  const {
    classes,
    selected,
    total,
  } = props

  const progress = parseInt(Math.min(((selected / total) * 100), 100), 10)

  return (
    <div className={`${classes.statusContainer}`} >
      <div className={`${classes.completion} ${(selected !== undefined) && 'visible'}`} >
        {`Schritt ${selected} (${progress}%)`}
      </div>
      <div className={`${classes.statusBarContainer}`} >
        <div
          className={`${classes.statusBar}`}
          style={{
            width: `${progress}%`,
          }}
        />
      </div>
    </div>
  )
}

const styles = theme => ({
  statusContainer: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    padding: `0 ${theme.sizes.gutter / 2}px`,
  },
  completion: {
    width: '100%',
    textAlign: 'center',
    color: theme.colors.secondary_3b,
    opacity: 0,
    '&.visible': {
      opacity: 1,
    },
  },
  statusBarContainer: {
    position: 'relative',
    height: '20px',
    width: '100%',
    maxWidth: '300px',
    backgroundColor: theme.colors.secondary_3a,
    borderRadius: '5px',
    overflow: 'hidden',
  },
  statusBar: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    backgroundColor: theme.colors.main_1,
    transition: [
      {
        property: 'width',
        duration: theme.speed.fast,
      },
    ],
  },
})

export default injectSheet(styles)(StatusBar)



// WEBPACK FOOTER //
// ./src/modules/core/components/statusBar.jsx